//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const UnExecutedGrantAgreementsWidget = ({ count }: { count: number }) => {
  return (
    <StatCard title='Un-Executed Grant Agreements' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />
  );
};

export default UnExecutedGrantAgreementsWidget;
